module.exports = require("babel-runtime/core-js/map");